import {useState} from 'react';

export type UseModalPopupOptions = {
  defaultOpen: boolean
}

const defaultOptions: UseModalPopupOptions = {
  defaultOpen: false
};

export const useModalPopup = ({defaultOpen}: UseModalPopupOptions = defaultOptions) => {
  const [open, setOpen] = useState<boolean>(defaultOpen);
  const openPopup = () => setOpen(true);
  const closePopup = () => setOpen(false);

  return {open, openPopup, closePopup};
};
